function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m360 293.015v-82.452l-38.51-53.913a8 8 0 0 1 13.02-9.3l16.39 22.941 42.24-70.407a8 8 0 0 1 6.86-3.884h43.736l-76.969-47.365c-16.89 4.84-97.608 30.364-159.7 91.621l-40.695 133.712c24.464 9.881 88.693 29.532 193.628 19.047z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m360 336.932v-27.832c-20.854 2.032-40.18 2.9-57.961 2.9-72.1 0-118.91-14.225-140.339-22.676l-8.026 26.37c8.4 3.637 25.617 10.234 50.814 15.712 32.829 7.133 86.084 13.724 155.512 5.526z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m296.476 356.716c-29.912 0-62.937-2.55-96.193-9.856-29.77-6.541-48.8-14.484-56.36-18l-106.074 49.5a324.058 324.058 0 0 0 52.761 39.076c35.538 21.243 93.08 46.564 165.39 46.564a408.715 408.715 0 0 0 166.159-35.045 339.923 339.923 0 0 0 50.107-27.47l-105.552-49.257a564.076 564.076 0 0 1 -70.238 4.488z"
});

function SvgWitchHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Solid",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWitchHat);
export default __webpack_public_path__ + "static/media/witch-hat.3fb22da8.svg";
export { ForwardRef as ReactComponent };